import { Category } from "../nyt";
import { HydratedBook } from "../stateMachine/gameStateMachine";

export interface Answer {
  bookTitle: string;
  id: string;
  correctCategory: number;
  givenCategory: number;
  reason?: string;
  img: string;
  score: number;
}

export default function sortCorrectAndIncorrectAnswers(
  userSelections: HydratedBook[][],
  booksCategorizedByOpenAI: Category[]
): Answer[] {
  const answerKey = booksCategorizedByOpenAI.reduce((acc, category, index) => {
    category.books.forEach((book) => {
      acc[book.title] = index;
    });
    return acc;
  }, {} as Record<string, number>);

  console.log("Start");

  console.log(userSelections);

  const answers = userSelections.flatMap((selections, categoryIndex) => {
    console.log(selections);
    return selections.map((selection) => {
      return {
        bookTitle: selection.title,
        id: selection.id,
        correctCategory: answerKey[selection.title],
        givenCategory: categoryIndex,
        img: selection.image,
        score: 0,
      };
    });
  });
  console.log(answers);

  console.log("end");

  return answers;
}
